module.exports = vendor.ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "vendor.ReactDOM"
// module id = 255
// module chunks = 0